import { apis } from 'probonio-shared-ui/module/api';

export const keyWithTenant = (tenantId: string, queryKey: string[]): string[] => ['tenants', tenantId].concat(queryKey);

export const CONDITIONS_LIST_QUERY_KEY = ['benefits', 'bikeleasing', 'conditions', apis.bikeLeasing.listConditions.name];

export const CREATE_CONDITION_KEY = (tenantId: string): string[] => keyWithTenant(tenantId, ['benefits', 'bikeleasing', 'conditions']);
